import firebase from "firebase/app";
import firebaseOrg, { db } from "./firebase";

export default {
  state: {
    account: {},
    user: {},
    accountsList: [],
  },
  mutations: {
    saveAccountInfo: (state, payload) => {
      state.account = { ...payload };
    },
    saveUserInfo: (state, payload) => {
      state.user = { ...payload };
    },
    saveNewAccount: (state, payload) => {
      state.accountsList = [{ ...payload }, ...state.accountsList];
    },
    saveAccountList: (state, payload) => {
      state.accountsList = [
        ...payload.filter((doc) => doc.authority === "sales"),
      ];
    },
    cleanAccountInfo: (state) => {
      state.user = {};
      state.account = {};
    },
    updateAccount: (state, payload) => {
      const { id, ...updateData } = payload;
      const index = state.accountsList.map((a) => a.id).indexOf(id);
      const newAccountsList = [...state.accountsList];
      newAccountsList.splice(index, 1, {
        ...state.accountsList[index],
        ...updateData,
      });
      state.accountsList = [...newAccountsList];
    },
    saveSecondaryApp: (state, payload) => {
      state.secondaryApp = payload;
    }
  },
  actions: {
    accountLogin: async ({ commit }, { email, password }) => {
      try {
        const loginInfo = await firebaseOrg
          .auth()
          .signInWithEmailAndPassword(email, password);
        commit("saveAccountInfo", { ...loginInfo.user });
        return { state: true };
      } catch (error) {
        console.log(error);
        return { state: false, error };
      }
    },
    accountLogout: ({ commit }) => {
      firebaseOrg.auth().signOut();
      commit("cleanAccountInfo");
    },
    queryUser: async ({ commit }, { uid }) => {
      const ref = db.collection("Accounts");
      const snapshot = await ref.doc(uid).get();
      commit("saveUserInfo", { id: snapshot.id, ...snapshot.data() });
    },
    queryAccountList: async ({ commit }) => {
      const ref = db.collection("Accounts");
      const snapshot = await ref.get();
      const accounts = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      commit("saveAccountList", accounts);
    },
    registeAccount: async ({ state, commit }, payload) => {
      const { email, password, ...other } = payload;

      var config = {
        apiKey: process.env.VUE_APP_API_KEY,
        authDomain: process.env.VUE_APP_AUTH_DOMAIN,
        databaseURL: process.env.VUE_APP_DATABASE_URL,
        projectId: process.env.VUE_APP_PROJECT_ID,
        storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
        messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
        appId: process.env.VUE_APP_APP_ID,
        measurementId: process.env.VUE_APP_MEASUREMENT_ID,
      };

      let secondaryApp =
        state.secondaryApp || firebase.initializeApp(config, "Secondary");
      if (!state.secondaryApp) commit("saveSecondaryApp", secondaryApp);

      try {
        const response = await secondaryApp
          .auth()
          .createUserWithEmailAndPassword(email, password);
        secondaryApp.auth().signOut();
        const newRef = db.collection("Accounts").doc(response.user.uid);
        await newRef.set({ email, ...other });
        commit("saveNewAccount", { id: response.user.uid, email, ...other });
        return { success: true };
      } catch (error) {
        console.log(error);
        return { ...error, success: false };
      }
    },
    archiveAccount: async ({ commit }, { id }) => {
      const ensure = prompt('若確定刪除此帳號請輸入「確定刪除」');
      if (ensure === '確定刪除') {
        const ref = db.collection("Accounts").doc(id);
        await ref.update({ isArchive: true });
        commit("updateAccount", { id, isArchive: true });
        return true;
      }
    },
  },
  getters: {},
};
